export default class Itinerary {
    airport: number;
    byland: string;
    cc: string;
    city: string;
    class: string;
    code: string;
    country: string;
    currency: string;
    departure_date: string;
    id: number;
    lat: number;
    long: number;
    name: string;
    state: string;

    constructor() {
        this.airport = 0;
        this.byland = '';
        this.cc = '';
        this.city = '';
        this.class = '';
        this.code = '';
        this.country = '';
        this.currency = '';
        this.departure_date = '';
        this.id = 0;
        this.lat = 0;
        this.long = 0;
        this.name = '';
        this.state = '';
    }
}